// extracted by mini-css-extract-plugin
export default {"claim-overview-row":"claimOverview_claim-overview-row__u-xb7","edit-claim-btn-wrapper":"claimOverview_edit-claim-btn-wrapper__sxsM-"};